import axios from 'axios';
import { baseURL } from './APIService';

export const postAuth = async (username: string, sso: boolean) => {
  const response = await axios.post(baseURL + 'login', {
    username: username,
    sso: sso
  });
  return response.data;
};

export const postSso = async (sso: boolean) => {
  const response = await axios.post(baseURL + 'initiate-sso', {
    sso: sso
  });
  return response.data;
};

export const postSsoCallback = async (code: string) => {
  const response = await axios.post(baseURL + 'callback', {
    code: code
  });
  return response.data;
};

export const postValidateToken = async (token: string) => {
  const response = await axios.post(baseURL + 'token', {
    token: token
  });
  return response.data;
};
